import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20",
  class: "arrows-up-down_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.756 8.16 5 3.406.244 8.16l1.179 1.178 2.744-2.744V15h1.666V6.595L8.577 9.34l1.179-1.178ZM15 16.178l-4.756-4.756 1.178-1.178 2.745 2.744V4.583h1.666v8.405l2.744-2.744 1.179 1.178L15 16.178Z"
    }, null, -1)
  ]))]))
}
export default { render: render }